/* eslint-disable */
import React, { useEffect } from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const currentlyTaking = useStore((state) => state.currentlyTaking);
  const setCurrentlyTaking = useStore((state) => state.setCurrentlyTaking);
  const usedGlp = useStore((state) => state.usedGlp);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>
          {usedGlp === 'Currently using'
            ? t('onboarding.currentlyTaking.title')
            : t('onboarding.currentlyTaking.title2')}
        </Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={currentlyTaking}
          onChange={(value: string) => {
            setCurrentlyTaking(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'currently-taking',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Liraglutide (Victoza, Saxenda)'}>
            {t('onboarding.currentlyTaking.options.liraglutide')}
          </Option>
          <Option value={'Tirzepatide (Mounjaro, Zepbound)'}>
            {t('onboarding.currentlyTaking.options.tirzepatide')}
          </Option>
          <Option value={'Semaglutide (Ozempic, Wegovy)'}>
            {t('onboarding.currentlyTaking.options.semaglutide')}
          </Option>
          <Option value={'Oral GLP-1 medication'}>
            {t('onboarding.currentlyTaking.options.oralGlp')}
          </Option>
          <Option value={'Other'}>{t('onboarding.currentlyTaking.options.other')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
